import type { FunctionComponent } from 'react';

/**
 * Root generic FOSSA text, wrapped in a simple <span> tag.
 *
 * @param {React.ReactNode} children - The text to display
 */
const Text: FunctionComponent = ({ children }) => (
  <span className="fossa-text">
    {children}
  </span>
);

export default Text;
